import { useMutation } from '@tanstack/react-query';
import { AuthState, initialState } from 'features/auth';
import { auth } from 'lib/api/firebase';
import { useAppSelector } from 'lib/store/rootReducer';
import { createContext, useContext } from 'react';

export function useSignInWithCustomTokenMutation() {
  return useMutation({
    mutationFn: auth.signInWithCustomToken.bind(auth)
  });
}

/**
 * Get the current auth user from the redux store
 * @returns The User or undefined
 */
export function useReduxAuthStore() {
  return useAppSelector(_ => _.auth);
}

const _AuthContext = createContext<AuthState>(initialState);
export const AuthContext = _AuthContext.Provider;

export function useAuth() {
  const ctx = useContext(_AuthContext);

  return ctx;
}
